import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ChartExportFacade } from '@mode/file-exports/domain';
import { FileExportDomain } from '@mode/shared/contract-common';
import { AnalyticsEvent } from '@mode/shared/util-segment';
import { Observable, first } from 'rxjs';

@Component({
  selector: 'mode-file-exports-drawer-container',
  templateUrl: './file-exports-drawer-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileExportsDrawerContainerComponent implements OnInit {
  @Input() drawerContext: string | undefined = 'editor'; // editor

  downloads$: Observable<readonly FileExportDomain.FileExport[]> | undefined;
  visible$!: Observable<boolean>;
  expanded$!: Observable<boolean>;

  constructor(private chartExportFacade: ChartExportFacade) {}

  ngOnInit(): void {
    this.downloads$ = this.chartExportFacade.allExports$;
    this.visible$ = this.chartExportFacade.drawerIsOpen$;
    this.expanded$ = this.chartExportFacade.drawerIsExpanded$;
  }

  onDownloadCsv(id: string) {
    this.chartExportFacade.downloadChartDesignerCsv(id);
  }

  onRetryDownloadCsv(id: string) {
    this.chartExportFacade.retryExport(id);
  }

  onDeleteCsv(id: string) {
    this.chartExportFacade.removeExport(id);
  }

  onCloseDrawer() {
    this.chartExportFacade.updateDrawerState(false);
  }

  onExpandDrawer() {
    this.chartExportFacade.drawerIsExpanded$.pipe(first()).subscribe({
      next: (expanded) => {
        this.chartExportFacade.updateDrawerExpanded(!expanded);
      },
    });
  }
}
